import React from "react";
import { useTranslation } from "react-i18next";
import { differenceInDays } from "date-fns";
import Badge from "@/components/ui/badge";
import Text, { TextVariant } from "@/components/ui/text";
import { formatFullDate } from "@/utils/datetime";

interface Props {
  value: string | null | undefined;
  valueVariant: TextVariant;
}

const EMPTY_VALUE = "-";

const NextRenewalKPI: React.FC<Props> = ({ value, valueVariant }) => {
  const { t } = useTranslation();

  if (!value) {
    return <Text variant={valueVariant}>{EMPTY_VALUE}</Text>;
  }

  const days = differenceInDays(new Date(value), new Date());
  const isPast = days < 0;
  const absDays = Math.abs(days);
  const unit = t(absDays === 1 ? "dateTime.day" : "dateTime.days");
  const badgeLabel = isPast
    ? t("contracts.kpis.daysAgo", { count: absDays, unit })
    : t("contracts.kpis.inDays", { count: days, unit });

  return (
    <div className="flex items-center gap-2 min-w-0">
      <Text variant={valueVariant} className="truncate">
        {formatFullDate(value)}
      </Text>
      <Badge selected className="border-none">
        <Text variant="smBody">{badgeLabel}</Text>
      </Badge>
    </div>
  );
};

export default NextRenewalKPI;
